import React from 'react'
import cx from 'classnames'

import Box from './box'
import Flex from './flex'

import VgHeadImg from '../../images/vg-head.png'

const VgTip = ({ className, children, noIcon }) => {
  const classes = cx(className, 'm-vg-tip')

  return (
    <Flex className={classes}>
      {!noIcon && <Box className="m-vg-tip__image">
        <img
          className="m-vg-tip__image"
          src={VgHeadImg}
        />
      </Box>}
      <Box className="m-vg-tip__body">
        {children}
      </Box>
    </Flex>
  )
}

export default VgTip
